<template>
	<div class="advert-manage-container">
		<!-- 数据卡片 -->
		<InfoCards :data="assetStats" />
		<!-- 搜索条件 -->
		<QueryCard @search="handleSearch" @reset="handleReset">
			<template slot="base">
				<el-col :span="6">
					<el-input v-model="query.keyword" placeholder="请输入资产编号/名称" />
				</el-col>
				<el-col :span="6">
					<el-select v-model="query.assetCategory" placeholder="请选择资产分类" clearable style="width: 100%">
						<el-option v-for="(item, index) in []" :key="index" :label="item.name" :value="item.value" />
					</el-select>
				</el-col>
				<el-col :span="6">
					<el-select v-model="query.depreciationStatus" placeholder="请选择折旧状态" clearable style="width: 100%">
						<el-option v-for="(item, index) in []" :key="index" :label="item.name" :value="item.value" />
					</el-select>
				</el-col>
			</template>
		</QueryCard>

		<!-- 表格 -->
		<BaseTable
			:actions="{
				operation: true,
			}"
			:loading="loading"
			:data="tableData"
			:columns="columns"
			:total="total"
			:pageNum="query.pageNum"
			:pageSize="query.pageSize"
			@page-change="pageChange"
			@size-change="sizeChange"
			@selection-change="handleSelectionChange">
			<template slot="toolbar">
				<el-button type="primary" size="small" icon="el-icon-plus" :disabled="!multipleSelection.length" @click="handleMerge">批量设置参数</el-button>
				<el-button size="small" icon="el-icon-set-up" @click="handleOneClickDepreciation">一键计提</el-button>
			</template>
			<template #assetCategory="{ row }">
				{{ $menu.getLabel('AssetCategory', row.assetCategory) }}
			</template>
			<template #depreciationMethod="{ row }">
				{{ $menu.getLabel('DepreciationMethod', row.depreciationMethod) }}
			</template>
			<template #depreciationStatus="{ row }">
				{{ $menu.getLabel('DepreciationStatus', row.depreciationStatus) }}
			</template>
			<template #assetNo="{ row }">
				<div class="table-assetCode" @click="handleQrcode(row)">
					<span>
						{{ row.assetNo }}
					</span>
					<i class="fa fa-qrcode" style="color: #409eff; font-size: 20px; cursor: pointer"></i>
				</div>
			</template>
			<template #status="{ row }">
					<el-tag :type="statusTagMap[row.depreciationStatus] || 'default'" size="small">
						{{ statusMap[row.depreciationStatus] || '-' }}
					</el-tag>
				</template>
			<template #operation="{ row }">
					<el-button type="text" @click="handleShow(row)">查看</el-button>
					<template>
						<el-button v-if="row.depreciationStatus == 'CALCULATING'" type="text" @click="handleDepreciation(row)">计提</el-button>
						<el-button v-if="row.depreciationStatus == 'NOT_CALCULATED'" type="text" @click="handleSplit(row)">设置参数</el-button>
					</template>
					<el-button style="color: #f56c6c" v-if="row.depreciationStatus == 'CALCULATING'" type="text" @click="handleStopDepreciation(row)">
						停止
					</el-button>
				</template>
		</BaseTable>
		<AssetDepreciationDialog :dialogVisible.sync="dialogDepreciationVisible" :data="currentRow" @updateSuccess="onDepreciationSuccess" />
		<AssetDepreciationParamDialog :dialogVisible.sync="dialogDepreciationParamVisible" :data="currentRow" @updateSuccess="getList" />
		<AssetDepreciationBatchParamDialog :dialogVisible.sync="dialogBatchParamVisible" :assetIds="batchAssetIds" @updateSuccess="onBatchSuccess" />
		<AssetDepreciationStopDialog :dialogVisible.sync="dialogDepreciationStopVisible" :data="currentRow" @updateSuccess="getList" />
		<AssetDepreciationDetailDrawer :dialogVisible.sync="drawerVisible" :data="currentRow" />
	</div>
</template>

<script>
	import AssetDepreciationDialog from '@/components/asset/assetDepreciationDialog';
	import AssetDepreciationParamDialog from '@/components/asset/assetDepreciationParamDialog';
	import AssetDepreciationBatchParamDialog from '@/components/asset/assetDepreciationBatchParamDialog';
	import AssetDepreciationStopDialog from '@/components/asset/assetDepreciationStopDialog';
	import AssetDepreciationDetailDrawer from '@/components/asset/assetDepreciationDetailDrawer';
	import { getDepreciationPage, getDepreciationStatistics, oneClickDepreciation } from '@/api/asset/assetLedgerApi';
  import { getCommunityId } from '@/utils/vc.js';
	export default {
		name: 'DepreciationManage',
		components: {
			AssetDepreciationDialog,
			AssetDepreciationParamDialog,
			AssetDepreciationBatchParamDialog,
			AssetDepreciationStopDialog,
			AssetDepreciationDetailDrawer,
		},
		data() {
      const communityId = getCommunityId();
			return {
        communityId: communityId,
				assetStats: [
					{ label: '可折旧资产', value: 0, unit: '个', color: '#5B8FF9' },
					{ label: '已设置参数', value: 0, unit: '个', color: '#61DDAA' },
					{ label: '本月计提总额', value: 0, unit: '万元', color: '#F6BD16' },
					{ label: '累计计提总额', value: 0, unit: '万元', color: '#7262FD' },
					{ label: '未计提资产', value: 0, unit: '个', color: '#FF9D4D' },
					{ label: '已停止计提', value: 0, unit: '个', color: '#FF6E76' },
				],
				total: 0,
				query: {
					assetCategory: '',
					assetName: '',
					assetNo: '',
					communityId: communityId,
					depreciationStatus: '',
					keyword: '',
					pageNum: 1,
					pageSize: 10,
					status: '',
				},
				tableData: [],
				columns: [
					{ prop: 'assetNo', label: '资产编号', width: 150 },
					{ prop: 'assetName', label: '资产名称', width: 180 },
					{ prop: 'assetCategory', label: '资产大类', width: 120, slot: 'assetCategory' },
					{ prop: 'originalValueWan', label: '原值(万元)', width: 120 },
					{ prop: 'netValueWan', label: '当前净值(万元)', width: 140 },
					{ prop: 'residualValueWan', label: '预计净残值(万元)', width: 140 },
					{ prop: 'depreciationYears', label: '使用年限(年)', width: 120 },
					{ prop: 'depreciationMethod', label: '折旧方法', width: 120, slot: 'depreciationMethod' },
					{ prop: 'monthlyDepreciation', label: '月折旧额(元)', width: 140 },
					{ prop: 'accumulatedDepreciationWan', label: '累计折旧(万元)', width: 140 },
					{ prop: 'depreciationStatus', label: '折旧状态', width: 120, slot: 'depreciationStatus' },
				],
				loading: false,
				currentRow: {},
				multipleSelection: [],
				drawerVisible: false,
				dialogDepreciationVisible: false,
				dialogDepreciationParamVisible: false,
				dialogBatchParamVisible: false,
				dialogDepreciationStopVisible: false,
			};
		},
		created() {
			this.getList();
			this.getDepreciationStats();
		},
		computed: {
			batchAssetIds() {
				return this.multipleSelection.map(item => item.id);
			},
		},
		methods: {
			async getList() {
				try {
					this.loading = true;
					const res = await getDepreciationPage(this.query);
					this.total = res.total;
					this.tableData = res.records || [];
				} catch (err) {
					console.log(err);
				} finally {
					this.loading = false;
				}
			},
			async getDepreciationStats() {
				try {
					const res = await getDepreciationStatistics({
            communityId: this.communityId,
          });
					this.assetStats = [
						{ label: '可折旧资产', value: res.depreciableCount || 0, unit: '个', color: '#5B8FF9' },
						{ label: '已设置参数', value: res.paramSetCount || 0, unit: '个', color: '#61DDAA' },
						{ label: '本月计提总额', value: parseFloat(res.currentMonthDepreciation) || 0, unit: '万元', color: '#F6BD16' },
						{ label: '累计计提总额', value: parseFloat(res.totalDepreciation) || 0, unit: '万元', color: '#7262FD' },
						{ label: '未计提资产', value: res.notCalculatedCount || 0, unit: '个', color: '#FF9D4D' },
						{ label: '已停止计提', value: res.stoppedCount || 0, unit: '个', color: '#FF6E76' },
					];
				} catch (err) {
					console.log(err);
				}
			},
			pageChange(page) {
				this.query.pageNum = page;
				this.getList();
			},
			sizeChange(size) {
				this.query.pageSize = size;
				this.getList();
			},
			handleSearch() {
        this.query.pageNum = 1;
				this.getList();
			},
			handleReset() {
				this.query = {
					assetCategory: '',
					assetName: '',
					assetNo: '',
					communityId: this.communityId,
					depreciationStatus: '',
					keyword: '',
					pageNum: 1,
					pageSize: 10,
					status: '',
				};
				this.getList();
			},

			handleSelectionChange(val) {
				this.multipleSelection = val || [];
			},

			handleMerge() {
				if (!this.multipleSelection.length) {
					this.$message.warning('请先选择要设置参数的资产');
					return;
				}
				this.dialogBatchParamVisible = true;
			},

			onBatchSuccess() {
				this.getList();
				this.getDepreciationStats();
			},

			handleOneClickDepreciation() {
				this.$confirm('确认执行一键计提（当月）操作吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(async () => {
						try {
							await oneClickDepreciation({ communityId: this.communityId });
							this.$message.success('一键计提成功');
							this.getList();
							this.getDepreciationStats();
						} catch (err) {
							this.$message.error(err.message || '一键计提失败');
						}
					})
					.catch(() => {});
			},

			handleSplit(row) {
				this.currentRow = row;
				this.dialogDepreciationParamVisible = true;
			},
			handleDepreciation(row) {
				this.currentRow = row;
				this.dialogDepreciationVisible = true;
			},
			onDepreciationSuccess() {
				this.getList();
				this.getDepreciationStats();
			},
			handleStopDepreciation(row) {
				this.currentRow = row;
				this.dialogDepreciationStopVisible = true;
			},

			handleShow(row) {
				this.currentRow = row;
				this.drawerVisible = true;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.advert-manage-container {
		padding: 20px;
		text-align: left;
	}
</style>